<p-dialog
  #addWindow
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h3>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.add-manual.title' | translate }}</h3>
  </ng-template>

  <div class="container-fluid form-horizontal">
    <form #addManualForm="ngForm">
      <p>
        <button app-add-button class="atlas-btn atlas-btn-primary" [label]="'common.add' | translate | titlecase" (click)="add()"> </button>
      </p>

      <div class="form-group" *ngFor="let recipient of recipients; let ndx = index">
        <div class="col-sm-6">
          <div *ngIf="!ndx">
            <label>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.add-manual.name-label' | translate | titlecase }}</label>
          </div>
          <input type="text" #nameField="ngModel" [name]="'name-' + ndx" class="form-control" [(ngModel)]="recipient.Name" />
        </div>
        <div class="col-sm-6">
          <div *ngIf="!ndx">
            <label>{{ 'communications.mass-comm-message-edit.mass-comm-profiles.add-manual.email-label' | translate | titlecase }}</label>
          </div>
          <input
            type="email"
            #emailField="ngModel"
            [name]="'email-' + ndx"
            class="form-control"
            [(ngModel)]="recipient.Email"
            [required]="!!recipient.Name"
          />
          <div class="text-danger" [hidden]="!submitted || !emailField.invalid">
            {{ 'common.required' | translate | titlecase }}
          </div>
        </div>
      </div>
    </form>
  </div>

  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      (click)="accept()"
      icon="pi pi-save"
      [label]="'common.save' | translate | titlecase"
    ></button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary"
      (click)="this.showModal = false"
      icon="pi pi-ban"
      [label]="'common.cancel' | translate | titlecase"
    ></button>
  </ng-template>
</p-dialog>
